<template>
  <div id="header">
    <div :class="$mq === 'mobile' ? 'wrapper' : ''">
      <div :class="[$mq ==='mobile' ? 'line' : '', {TA:isTestAchat}]">

      <div class="languages" :class="[header,{TA:isTestAchat}]">
        <div class="border inline space-between">
          <a v-if="!isTestAchat" class="phone" :href="`tel:${$t('phoneHref')}`"><SvgIcon icon="phone" class="icon" fill></SvgIcon> {{ $t('phone') }}</a>
          <span class="language" @click="switchLocale()">{{ locale }}</span>
        </div>

        <div
          class="nav inline space-between"
          :class="[$mq !== 'mobile' ? 'container left' : 'mobile space-between', {TA:isTestAchat}]"
        >
          <a :href="getMegaUrl" target="_blank">
            <img src="@/assets/logoMegaHeader.svg" />
          </a>

          <div v-if="!isTestAchat" class="partner">
            <!-- <img class="partner" src="@/assets/Bemove.png" /> -->
            <img :src="partner" v-if="partner" />
            <span v-if="!partner && agentCustomId">{{ showAgentCustomId() }}</span>
          </div>

          <div v-if="isTestAchat" class="partner inline" :class="$mq">
            <!-- <img :src="partner" v-if="partner" /> -->
            <h3 style="max-width: 160px; color: #231F20; margin-right: 40px">{{ $t('branding.special_offer') }}</h3>
            <a :href="getPartnerUrl" target="_blank" id="partner-logo"><img :src="require(`@/assets/logos/${getPartnerLogo}`)" v-if="isTestAchat" id="partner-logo-img"/></a>
          </div>

        </div>
      </div>
      </div>
      <!-- <div class="notification" v-if="notification && $i18n.locale === 'nl' && campaign !== 'WATZ'">
        <p>
          Ben je klant van de Vlaamse Energieleverancier? Dankzij Mega blijft jouw energielevering gegarandeerd. Stap gemakkelijk (online) over naar Mega, kies ons "VEL" product en behoud je oude variabele voorwaarden en profiteer van een aantrekkelijke korting! Wij voorzien je vanaf 7/12 van onze energie (met terugwerkende kracht en overname van je meterstanden), zonder enig risico van onderbreking.
        </p>
        <div class="close" @click="notification=false"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import haugazelService from "../services/haugazelService";
import 'moment/locale/fr'
import 'moment/locale/en-gb'

export default {
  data() {
    return {
      partner: null,
      notification: true
    };
  },
  computed: {
    ...mapState("subscription", ["agentCustomId", "campaign"]),
    ...mapGetters("subscription", ["isTestAchat"]),
    locale() {
      return this.$i18n.locale === "fr" ? "NL" : "FR";
    },
    header(){
      return this.$mq !== 'mobile' ? 'container-header' : '';
    },
    getPartnerLogo() {
      const lang = this.locale === 'NL' ? 'fr' : 'nl';
      return 'testachats_logo_'+lang+'.png';
    },
    getPartnerUrl() {
      return this.locale === 'NL' ? 'https://www.test-achats.be/energyguide/mes-achats-energie/action-speciale' : 'https://www.test-aankoop.be/energyguide/mijn-energie-aankopen/speciale-actie'; //TODO change to get it dynamically from back-end
    },
    getMegaUrl() {
      return this.locale === 'NL' ? 'https://www.mega.be/fr' : 'https://www.mega.be/nl';
    }
  },
  methods: {
    async partnerBranding() {
      if (this.$router.currentRoute.query["agent"]) {
        let response = await haugazelService.getPartner(
          this.$router.currentRoute.query["agent"]
        );

        if (
          response.valid &&
          moment(response.valid_from) <= moment() &&
          moment(response.valid_to) >= moment()
        ) {
          this.partner = `${process.env.FILE_STORE}/${response.file}`;
        }
      }
    },
    switchLocale() {
      let isDefault = this.$route.matched.find(matched => matched.name === 'Default')

      if (this.$i18n.locale === "fr") {
        this.$i18n.locale = 'nl';

        if(isDefault)
          this.$router.push({ name: this.$route.name, params: { locale: 'nl' }, query: this.$route.query });
      } else {
        this.$i18n.locale = 'fr';

        if(isDefault)
          this.$router.push({ name: this.$route.name, params: { locale: 'fr' }, query: this.$route.query });
      }
    },
    showAgentCustomId(){
      const regexAgent = /AG\d{6}/;

      if (this.agentCustomId.match(regexAgent)) {
        return this.agentCustomId;
      }

      return "";
    }
  },
};
</script>

<style lang="scss" scoped>
.languages {
  color: $grey;
  background: $white;

  .border {
    min-height: 40px;
    padding-top: 1px;
    padding-bottom: 2px;
    margin: 0 13px;
    border-bottom: 2px solid $lightGrey;
  }

  .phone {
    text-decoration: none;
    color: $black;
    display: flex;
    font-size: 0.85rem;
    font-weight: 600;
    padding: 12px 15px;

    .icon {
      margin-right: 5px;
      color: $black;
    }
  }

  .language {
    cursor: pointer;
    font-size: 0.91rem;
    font-weight: 400;
    padding: 12px 15px;
    transition: all 0.3s;

    &:hover {
      background: $yellow;
      color: $black;
    }
  }
  &.TA {
    .border {
      background-color: $orange!important;
      color: $white;
      justify-content: end;
      margin: 0;

        &:hover {
          background-color: $white;
          color: $black;
        }
      }
    .language {
      cursor: pointer;
      font-size: 0.91rem;
      font-weight: 400;
      padding: 12px 15px;
      transition: all 0.3s;

      &:hover {
        background: $white;
        color: $black;
      }
    }
  }
}

.nav {
  background: white;

  img {
    padding: 17px 14px;
    height: 56px;

    &.partner {
      height: 40px;
    }
  }

  &.mobile {

    > * {
      padding: 10px;
      flex: 1;

      img {
        width: 100%;
        padding: 0;
      }
    }
  }
}

.wrapper {
  // height: 120px;
  background: white;
  position: relative;

  .fixed {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    right: 0;
    background: white;
    border-bottom: 1px solid #fcc648;
  }

  .line {
    border-bottom: 1px solid #fcc648;

    &.TA {
      border-bottom: 1px solid $white!important;
    }
  }

  .icon-menu {
    margin-right: 10px;
    font-size: 1.8rem;
    color: #fdcb47;
  }

}

.notification {
  background: $clearYellow;
  padding: 10px 50px;
  display: flex;
  align-items: center;

  p {
    text-align: left;
    font-size: 0.75rem;
    margin: 0;
    padding: 0;
  }

  .close {
    cursor: pointer;
    margin-left: 20px;
    min-width: 18px;
    min-height: 18px;
    max-height: 18px;
    height: 18px;
    width: 18px;
    border-radius: 50%;
    background: no-repeat url('~@/assets/icons/icon-close.svg') center center/50% white;
  }
}

.partner {

  &.inline {
      flex:1;
      display: flex;
      align-items: center;
      justify-content: end;
      flex-wrap: wrap;
    }
  #partner-logo {
    padding:0;
    height: 90%;
    width: 90%;
  }

  #partner-logo-img {
    height: 100%;
    width: 100%;
  }

  h3 {
    font-size: 16px;
    font-weight: 700;
    margin:0;
  }

  &.desktop {
    flex-wrap: nowrap;



    h3 {
      font-size: 18px;
      margin-top: 10px;
    }

    #partner-logo {
    margin-left: 5px;
    height: 35%;
    width: 35%;
  }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue